// extracted by mini-css-extract-plugin
export default {"table":"table_table__hiyWB","head":"table_head__HpFDq","header":"table_header__xs0PE","row":"table_row__9vbUz","cell":"table_cell__zfKli"};